import PropTypes from 'prop-types';
import { UserSettingsOptions } from '../../../enums/user-settings/user-settings-options';

export const QuickshipSettingsType = PropTypes.shape({
  quickshipShowCostSummary: PropTypes.oneOf([
    UserSettingsOptions.quickshipAlwaysShowCostSummary.settingValue,
    UserSettingsOptions.quickshipShowCostSummaryIfNeeded.settingValue,
    UserSettingsOptions.quickshipNeverShowCostSummary.settingValue,
  ]),
  quickshipShowErrors: PropTypes.bool,
  quickshipShowLabelBatchStatus: PropTypes.bool,
  quickshipShowPrintDialogPreview: PropTypes.bool,
  quickshipShowWarnings: PropTypes.bool,
});

export const QuickshipSettingsDefaultProps = {
  quickshipShowCostSummary: UserSettingsOptions.quickshipNeverShowCostSummary.settingValue,
  quickshipShowErrors: false,
  quickshipShowLabelBatchStatus: false,
  quickshipShowPrintDialogPreview: false,
  quickshipShowWarnings: false,
};
